import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ThemeContext from '~app/components/Survey/ThemeContext';
import './qz-score-summary.scss';

const getScorePoints = ({ points, totalPoints }) => {
  if (points && totalPoints) {
    return (
      <span>
        {points}/{totalPoints} points
      </span>
    );
  }
  return null;
};

const QuizScoreSummary = ({ score }) => {
  const theme = useContext(ThemeContext);
  return (
    <div className="sm-qz-score-summary--container" style={theme.palette} data-testid="QuizScoreSummary__Container">
      <div className="sm-qz-score-summary--feedback">{score.feedback}</div>
      <div className="sm-qz-score-summary--score">Score: {score.score}</div>
      <div className="sm-qz-score-summary--points">{getScorePoints(score)}</div>
    </div>
  );
};

QuizScoreSummary.propTypes = {
  score: PropTypes.shape({
    feedback: PropTypes.string,
    score: PropTypes.string,
    points: PropTypes.string,
    totalPoints: PropTypes.string,
  }).isRequired,
};

export default QuizScoreSummary;
